import React from 'react';
import { Search, Command } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSearchContext } from './SearchProvider';

export const GlobalSearch = () => {
  const { setIsCommandPaletteOpen } = useSearchContext();

  return (
    <Button
        variant="outline"
        onClick={() => setIsCommandPaletteOpen(true)}
        className="relative w-64 justify-start text-muted-foreground hover:text-foreground"
      >
        <Search className="mr-2 h-4 w-4" />
        <span className="flex-1 text-left">Поиск...</span>
        <kbd className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100">
          <Command className="h-3 w-3" />
          <span>K</span>
        </kbd>
    </Button>
  );
};